import { render } from "./ExportProductosRecomendados.vue?vue&type=template&id=24bf03e6"
import script from "./ExportProductosRecomendados.vue?vue&type=script&lang=js"
export * from "./ExportProductosRecomendados.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__